'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALIGN_CENTER = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graph = require('./graph');

var _graph2 = _interopRequireDefault(_graph);

var _const = require('./const');

var _lodash = require('lodash');

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GraphJS = function () {
  _createClass(GraphJS, null, [{
    key: 'create',
    value: function create() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          items = _ref.items,
          start = _ref.start,
          alignment = _ref.alignment,
          parsers = _ref.parsers,
          formatters = _ref.formatters;

      var g = new GraphJS({ parsers: parsers, formatters: formatters });
      g.graph = new _graph2.default.create(alignment);
      g.setItems(items, start);
      return g;
    }
  }, {
    key: 'createFrom',
    value: function createFrom() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          graph = _ref2.graph,
          parsers = _ref2.parsers,
          formatters = _ref2.formatters;

      var g = new GraphJS({ parsers: parsers, formatters: formatters });
      g.graph = new _graph2.default.create(graph.alignment, graph);
      return g;
    }
  }]);

  function GraphJS() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$parsers = _ref3.parsers,
        parsers = _ref3$parsers === undefined ? [] : _ref3$parsers,
        _ref3$formatters = _ref3.formatters,
        formatters = _ref3$formatters === undefined ? [] : _ref3$formatters;

    _classCallCheck(this, GraphJS);

    this.parsers = parsers;
    this.formatters = formatters;
  }

  _createClass(GraphJS, [{
    key: 'parse',
    value: function parse(items, start) {
      var _this = this;

      var nextParser = function nextParser(index) {
        return function () {
          var mutableItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : items;
          var mutableStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : start;

          if (index < _this.parsers.length) {
            return _this.parsers[index](nextParser(index + 1), mutableItems, mutableStart);
          }
          return { items: mutableItems, start: mutableStart };
        };
      };
      return nextParser(0)(_.cloneDeep(items), start);
    }
  }, {
    key: 'format',
    value: function format(items, start) {
      var _this2 = this;

      var nextFormatter = function nextFormatter(index) {
        return function () {
          var mutableItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : items;
          var mutableStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : start;

          if (index < _this2.formatters.length) {
            return _this2.formatters[index](nextFormatter(index + 1), mutableItems, mutableStart);
          }
          return { items: mutableItems, start: mutableStart };
        };
      };

      return nextFormatter(0)(_.cloneDeep(items), start);
    }
  }, {
    key: 'setItems',
    value: function setItems(originalItems, originalStart) {
      var _parse = this.parse(originalItems, originalStart),
          items = _parse.items,
          start = _parse.start;

      this.graph.setItems(items, start);
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      return this.format(this.graph.items, this.graph.start);
    }
  }, {
    key: 'insert',
    value: function insert(item, parentId, childId) {
      var siblingIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      return this.graph.insert(item, parentId, childId, siblingIndex);
    }
  }, {
    key: 'add',
    value: function add(item, parentId, siblingIndex) {
      return this.insert(item, parentId, undefined, siblingIndex);
    }
  }, {
    key: 'remove',
    value: function remove(itemId) {
      return this.graph.remove(itemId);
    }
  }, {
    key: 'build',
    value: function build() {
      return this.graph.build();
    }
  }, {
    key: 'findPaths',
    value: function findPaths(firstId, lastId) {
      return this.graph.findPaths(firstId, lastId);
    }
  }, {
    key: 'items',
    get: function get() {
      return this.graph.items;
    }
  }, {
    key: 'edges',
    get: function get() {
      return this.graph.edges;
    }
  }]);

  return GraphJS;
}();

exports.default = GraphJS;
exports.ALIGN_CENTER = _const.ALIGN_CENTER;